import React from 'react';
import { motion } from 'framer-motion';

const AnnaProof = () => (
  <section className="relative py-28 bg-dark overflow-hidden border-t border-white/5">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(212,175,55,0.05)_0%,transparent_65%)]" />
    <div className="relative z-10 max-w-4xl mx-auto px-6">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-gold tracking-[0.3em] uppercase text-xs mb-12 text-center font-semibold"
      >
        Echte Transformation · Annas Geschichte
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="relative p-10 md:p-16 rounded-sm overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.04)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 0 80px rgba(212,175,55,0.06), inset 0 0 60px rgba(212,175,55,0.02)',
        }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-gold/5 blur-[80px] rounded-full pointer-events-none" />
        <div
          className="absolute top-0 left-0 right-0 h-[1px]"
          style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.4), transparent)' }}
        />

        <div className="relative z-10 space-y-8">
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl font-serif text-cream/90 leading-relaxed italic"
          >
            "Über ein Jahr lang lebte ich in einer Affäre. Der Kreislauf war immer derselbe:
            Nähe, dann Rückzug, dann <span className="text-wine-light">Panik.</span> Ich schaute
            hunderte Male am Tag auf mein Handy. Ich überschritt jede Grenze, die ich mir je
            selbst gesetzt hatte."
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="w-16 h-[1px] mx-auto"
            style={{ background: 'linear-gradient(to right, transparent, #D4AF37, transparent)' }}
          />

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
            className="text-lg text-cream/70 font-light leading-relaxed"
          >
            Dann, in einer einzigen Sitzung mit Jennifer, wurde alles klar:{' '}
            <span className="text-cream font-serif italic">
              Mein Nervensystem hatte ihn als seinen primären Regulator gespeichert.
            </span>{' '}
            Er war keine Liebesgeschichte. Er war eine Überlebensstrategie. Mein Körper hatte
            gelernt, seine Anwesenheit – und seine Abwesenheit – zu nutzen, um das eigene innere
            Chaos zu regulieren.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.7 }}
            className="p-8 border border-gold/20 relative"
            style={{ background: 'rgba(212,175,55,0.03)' }}
          >
            <p className="text-xl font-serif text-cream italic leading-relaxed">
              "Die Arbeit bestand darin, die Unbehaglichkeit der Ungewissheit in mir selbst zu{' '}
              <span className="text-gold">ertragen zu lernen</span> – ohne nach ihm zu greifen,
              damit es aufhört. In dem Moment, als ich das konnte?{' '}
              <span className="text-gradient-gold">Veränderte sich alles."</span>
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.9 }}
            className="flex items-center gap-4 pt-4 border-t border-white/10"
          >
            <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center text-gold font-serif text-lg">
              A
            </div>
            <div>
              <p className="text-cream font-semibold tracking-widest uppercase text-sm">Anna, 34</p>
              <p className="text-gold text-xs uppercase tracking-widest mt-0.5">Love Code Absolventin</p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default AnnaProof;